var React = require('react');

function StarSm (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M30 0L36.2117 6.81778L45 4.01924L46.9706 13.0294L55.9808 15L53.1822 23.7883L60 30L53.1822 36.2117L55.9808 45L46.9706 46.9706L45 55.9808L36.2117 53.1822L30 60L23.7883 53.1822L15 55.9808L13.0294 46.9706L4.01924 45L6.81778 36.2117L0 30L6.81778 23.7883L4.01924 15L13.0294 13.0294L15 4.01924L23.7883 6.81778L30 0Z","fill":"#FFEB35"}));
}

StarSm.defaultProps = {"width":"60","height":"60","viewBox":"0 0 60 60","fill":"none"};

module.exports = StarSm;

StarSm.default = StarSm;
